import type { ReactNode } from 'react';
import { QueryClientProvider } from '@tanstack/react-query';
import { useAuthStore } from './store';

export const SessionQueryProvider = ({ children }: { children: ReactNode }) => {
  const queryClient = useAuthStore((s) => s.queryClient);
  const sessionVersion = useAuthStore((s) => s.sessionVersion);

  // Remount observers and local patient state as well as replacing the cache.
  return (
    <QueryClientProvider key={sessionVersion} client={queryClient}>
      {children}
    </QueryClientProvider>
  );
};
